import { AddChoices } from 'apps/studio/components/choices'
import { HashIcon } from '@gocanvas/gcds/icons'
import { lib } from '@gocanvas/client'
const {
  referenceDataHooks,
  GC_BLANK_DEFAULT,
  MULTIPLE_CHOICE_BUTTONS_STYLE,
  SINGLE_CHOICE_BOXES_STYLE,
  SINGLE_CHOICE_RADIO_BUTTONS_STYLE,
  MULTIPLE_CHOICE_CHECKBOXES_STYLE,
} = lib
const { useReferenceDataOptions } = referenceDataHooks

const blankOption = {
  label: 'Blank',
  text: GC_BLANK_DEFAULT,
  value: GC_BLANK_DEFAULT,
}

const firstChoiceOption = {
  label: 'First Choice',
  text: '',
  value: '',
}

const specialDefaultOptions = {
  ALL: [blankOption, firstChoiceOption],
  BLANK: [blankOption],
}

const processOptions = (initialOptions, specialOptions) => {
  const userAddedOptions = initialOptions.reduce((acc, option) => {
    const { text, label } = option
    if (option.text) {
      acc.push({
        ...option,
        label: label || text,
        value: text,
      })
    }
    return acc
  }, [])

  return specialOptions
    ? [...specialDefaultOptions[specialOptions], ...userAddedOptions]
    : userAddedOptions
}

const showSpecialOptions = ({ type, style }) => {
  // Single Choice Dropdown
  if (type == 'Dropdown') {
    return 'ALL'
  }
  // Single Choice Radio Buttons
  if (type == 'Single Choice' && style == SINGLE_CHOICE_RADIO_BUTTONS_STYLE) {
    return 'ALL'
  }
  // Single Choice Boxes
  if (type == 'Single Choice' && style == SINGLE_CHOICE_BOXES_STYLE) {
    return 'BLANK'
  }
  // Checkboxes only?
  if (type == 'Multiple Choice' && style == MULTIPLE_CHOICE_CHECKBOXES_STYLE) {
    return 'ALL'
  }

  return false
}

const DefaultValueSelect = {
  label: 'Default Value',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'default',
  dynamicChoices: ({
    reference_data_id,
    reference_data_column,
    data_source_context_id,
    live_data_source_column,
    entry_values = [],
    type,
    style,
  }) => {
    const default_options =
      entry_values.length > 0 ? entry_values : [{ position: 0 }]
    const { options } = useReferenceDataOptions({
      reference_data_id,
      reference_data_column,
      data_source_context_id,
      live_data_source_column,
      default_options,
    })
    const specialOptions = showSpecialOptions({ type, style })
    return processOptions(options, specialOptions)
  },
  showInput: ({ style }) => style != MULTIPLE_CHOICE_BUTTONS_STYLE,
  isDisabled: ({ entry_values, reference_data_id, data_source_context_id }) =>
    !entry_values.length && !reference_data_id && !data_source_context_id
}

export const CHOICES_PANEL = 'Choices'

export const ChoicesSettings = [DefaultValueSelect]

export const ChoicesPanel = (settings = ChoicesSettings) => ({
  label: CHOICES_PANEL,
  icon: HashIcon,
  component: ({ entry }) => <AddChoices {...entry} />,
  settings,
})
